import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useAuth } from '@/contexts/AuthContext';
import { useSubscription } from '@/contexts/SubscriptionContext';
import { visibleTopics } from './onboarding-topics';

interface OnboardingDialogProps {
  open: boolean;
  onClose: () => void;
}

export function OnboardingDialog({ open, onClose }: OnboardingDialogProps) {
  const { user } = useAuth();
  const { hasFeature } = useSubscription();
  const navigate = useNavigate();
  const topics = visibleTopics(user?.role, hasFeature);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Bem-vinda ao soupelvi</DialogTitle>
          <DialogDescription>
            A maior parte do sistema é direta. Estes são os pontos que funcionam de um jeito um pouco
            diferente. Você pode rever esta página quando quiser pelo ícone de ajuda no topo.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          {topics.map((topic) => {
            const Icon = topic.icon;
            return (
              <section key={topic.id} className="rounded-lg border border-border p-4">
                <div className="flex items-start gap-3">
                  <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent">
                    <Icon className="h-4 w-4 text-accent-foreground" />
                  </div>
                  <div className="min-w-0 flex-1 space-y-2">
                    <h3 className="text-sm font-semibold">{topic.title}</h3>
                    <p className="text-sm text-muted-foreground">{topic.description}</p>
                    {topic.points && (
                      <ul className="list-disc space-y-1 pl-4 text-sm text-muted-foreground">
                        {topic.points.map((p) => (
                          <li key={p}>{p}</li>
                        ))}
                      </ul>
                    )}
                    {topic.to && (
                      <Button
                        variant="link"
                        size="sm"
                        className="h-auto p-0"
                        onClick={() => {
                          onClose();
                          navigate(topic.to as string);
                        }}
                      >
                        {topic.toLabel ?? 'Abrir'}
                      </Button>
                    )}
                  </div>
                </div>
              </section>
            );
          })}
        </div>

        <DialogFooter>
          <Button onClick={onClose}>Entendi</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
